import styled from "styled-components";

export const AppliedFilterIndicatorBox = styled.span`
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid ${props => props.theme.colors.boxBorderContrast};
    border-radius: 20px;
    padding: 0 10px;
    line-height: 3.4rem;
    margin-left: 2px;
`